import * as _ from "lodash"
import { DietPrescriptionItemRequest } from "@curefit/gmf-common";
import { IPrescription } from "@curefit/care-common";
import ModelFactory from "../models/ModelFactory";
import ILocalStorageObject from "../models/ILocalStorageObject";
import IMealSlot from "../models/IMealSlot";
import { ApiManager } from "../api/ApiManager";
import IMealItem from "../models/IMealItem";
import AppUtils from "./AppUtils";

export default class LocalStorageUtils {
    static setLocalStorageObject(localStorageObject: ILocalStorageObject) {
        if (!_.isEmpty(localStorageObject)) {
            let localStorageString = JSON.stringify(localStorageObject);
            localStorage.setItem("carefit-data", localStorageString)
        }
    }

    static getRootLocalStorageObject(): ILocalStorageObject {
        let localStorageObject = JSON.parse(localStorage.getItem("carefit-data"));
        if (_.isEmpty(localStorageObject)) localStorageObject = ModelFactory.createNewCarefitLocalStorageObject();
        return localStorageObject;
    }

    static savePrescription(consultationId: number, prescription: IPrescription) {
        let localStorageObject = this.getRootLocalStorageObject();
        let unsavedPrescriptions = localStorageObject.unsavedPrescriptions;
        if (!_.isEmpty(unsavedPrescriptions)) {
            let filteredPrescription = unsavedPrescriptions.filter(item => item.consultationId === consultationId);
            if (filteredPrescription.length > 0) {
                let indexOfPresciption = unsavedPrescriptions.map(item => item.consultationId).indexOf(consultationId);
                unsavedPrescriptions[indexOfPresciption] = { consultationId, prescription };
            } else {
                unsavedPrescriptions.push({ consultationId, prescription });
            }
        } else {
            unsavedPrescriptions = [];
            unsavedPrescriptions.push({ consultationId, prescription });
        }
        let updatedLocalStorageObject = { ...localStorageObject, unsavedPrescriptions }
        this.setLocalStorageObject(updatedLocalStorageObject);
    }

    static clearPrescription(consultationId: number) {
        let localStorageObject = this.getRootLocalStorageObject();
        let unsavedPrescriptions = localStorageObject.unsavedPrescriptions;
        if (!_.isEmpty(unsavedPrescriptions)) {
            let filteredPrescription = unsavedPrescriptions.filter(item => item.consultationId === consultationId);
            if (filteredPrescription.length > 0) {
                let indexOfPresciption = unsavedPrescriptions.map(item => item.consultationId).indexOf(consultationId);
                unsavedPrescriptions.splice(indexOfPresciption, 1);
            }
        }
        let updatedLocalStorageObject = { ...localStorageObject, unsavedPrescriptions }
        this.setLocalStorageObject(updatedLocalStorageObject);
    }

    static getPrescription(consultationId: number): IPrescription {
        let prescription = null;
        let localStorageObject = this.getRootLocalStorageObject();
        let unsavedPrescriptions = localStorageObject.unsavedPrescriptions;
        if (!_.isEmpty(unsavedPrescriptions)) {
            let filteredPrescription = unsavedPrescriptions.filter(item => item.consultationId === consultationId);
            if (filteredPrescription.length > 0) {
                prescription = filteredPrescription[0].prescription;
            }
        }
        return prescription;
    }

    static createMealsMap(dietPlan: any) {
        // _.map(prescriptionItems, (prescriptionItem: DietPrescriptionItemRequest) => {
        // if (_.isEmpty(prescriptionItem.editInfo) || (prescriptionItem.editInfo.nextStatus !== "CANCELLED")) {
        _.map(dietPlan.meals, (meal: IMealSlot) => {
            if (!_.isEmpty(meal.details) && !_.isEmpty(meal.details.mealIds)) {
                _.map(meal.details.mealIds, (mealId: string) => {
                    if (_.isEmpty(LocalStorageUtils.getMealFromMealId(mealId))) {
                        ApiManager.getRamsayApis().getMealByMealId(mealId).then((meal: IMealItem) => {
                            LocalStorageUtils.addMealToMap(meal);
                        })
                    }
                })
            }
        })
    }

    static createAdherenceMealsMap(meals: IMealItem[]) {
        if (!_.isEmpty(meals)) {
            meals.map((item: IMealItem) => {
                LocalStorageUtils.addMealToMap(item);
            })
        }
    }

    static getAllMealsFromMealIds(ids: string[]): IMealItem[] {
        return ids.map(id => LocalStorageUtils.getMealFromMealId(id))
    }

    static getMealFromMealId(mealId: string): IMealItem {
        let localStorageObject = this.getRootLocalStorageObject();
        let meals = localStorageObject.mealsMap;
        return !_.isEmpty(meals) ? meals[mealId] : null;
    }

    static addMealToMap(meal: IMealItem) {
        let localStorageObject = this.getRootLocalStorageObject();
        let meals = !_.isEmpty(localStorageObject.mealsMap) ? localStorageObject.mealsMap : {};
        meals[meal.mealId] = meal;
        let updatedLocalStorageObject = { ...localStorageObject, mealsMap: meals };
        this.setLocalStorageObject(updatedLocalStorageObject);
    }

    static setClickEvents(props: any) {
        if (props.field && typeof (props.field) === "string" && props.field.endsWith("| disabled")) {
            // preventing disabled events to be pushed to mix panel
            return;
        }
        props.consultationId = AppUtils.getConsultationIdFromOngoingUrl();
        let localStorageObject = LocalStorageUtils.getItems("clickEvents");
        localStorageObject = _.isEmpty(localStorageObject) ? [] : localStorageObject;
        localStorageObject.push(props)
        LocalStorageUtils.setItem("clickEvents", localStorageObject)
    }

    static setItem = (key: string, item: any) => {
        let localStorageString = JSON.stringify(item);
        try {
            localStorage.setItem(key, localStorageString);
        }
        catch (e) {
            console.error(e);
        }
    }
    static getItems = (key: string) => {
        if (key) {
            const lsItem = localStorage.getItem(key)
            return JSON.parse(lsItem)
        }
        return null
    }

    static remove = (keys: string[]) => {
        (keys || []).forEach((key: string) => {
            localStorage.removeItem(key)
        })
    }
}